module.exports = __webpack_public_path__ + "static/case-telekom-b66c28eb3738101810b15b78adc4f6b2.mp4";